<div class="cell auto cell-block-y" *ngIf="parameters">
    <h2 class="cell shrink _sansSerif _primary"[i18nKey]="'parameters.standing.menu.title'"></h2>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <h3 [i18nKey]="'parameters.standing.menu.standard.prices.title'"></h3>

    <p [i18nKey]="'parameters.standing.menu.standard.prices.description'"></p>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th>
            </th>
            <th [i18nKey]="'parameters.standing.menu.standard.prices.minimal.standing'"></th>
            <th [i18nKey]="'parameters.standing.menu.standard.prices.standard.standing'"></th>
            <th [i18nKey]="'parameters.standing.menu.standard.prices.maximal.standing'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.standing.menu.standard.prices.menu.price'"></td>
            <td>
                {{parameters.priceMinimalStanding | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td>
                {{parameters.priceStandardStanding | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td>
                {{parameters.priceMaximalStanding | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <h3 [i18nKey]="'parameters.standing.menu.dishes.weights.title'"></h3>

    <p [i18nKey]="'parameters.standing.menu.dishes.weights.description'"></p>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th>
            </th>
            <th [i18nKey]="'parameters.standing.menu.weight'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.standing.menu.dishes.weights.first.courses.price'"></td>
            <td>
                {{parameters.firstCoursesWeight}}
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.standing.menu.dishes.weights.main.courses.price'"></td>
            <td>
                {{parameters.mainCoursesWeight}}
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.standing.menu.dishes.weights.desserts.price'"></td>
            <td>
                {{parameters.dessertsWeight}}
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.standing.menu.dishes.weights.wines.price'"></td>
            <td>
                {{parameters.winesWeight}}
            </td>
        </tr>
        </tbody>
    </table>

    <h3 [i18nKey]="'parameters.standing.menu.menus.weights.title'"></h3>

    <p [i18nKey]="'parameters.standing.menu.menus.weights.description'"></p>

    <table class="_tableColor">
        <thead>
            <tr class="_titlePartTable">
                <th>
                </th>
                <th [i18nKey]="'parameters.standing.menu.weight2'"></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td [i18nKey]="'parameters.standing.menu.menus.weights.first.course.main.course.price'"></td>
                <td>
                    {{parameters.firstCourseMainCourseMenuWeight}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.standing.menu.menus.weights.main.course.dessert.price'"></td>
                <td>
                    {{parameters.mainCourseDessertMenuWeight}}
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.standing.menu.menus.weights.full.course.price'"></td>
                <td>
                    {{parameters.fullCourseWeight}}
                </td>
            </tr>
        </tbody>
    </table>
</div>
